/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React, {useState } from "react";

import AccountContainer from "./AccountContainer";
import EditAccountPane from "./EditAccountPane";



function EditAccount(props) {


  return (
    <AccountContainer>
      <EditAccountPane actionType="updateAccount" onSubmit={props.onSubmit} onCancel={props.onCancel} />
    </AccountContainer>
  );
}


export default EditAccount;
